import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment.prod';

const baseUrl = environment.baseUrl;
@Injectable({
  providedIn: 'root'
})
export class ForgotPasswordService {

  constructor(
    private httpClient: HttpClient
  ) { }

  passwordResetService(data: { email: string}) {
    const body = new HttpParams()
      .set('email', data.email)
      .set('forgot', 1)
      .set('device','web');
    return this.httpClient.post(baseUrl+'forgot.php', body.toString());
  }
  passwordMobileResetService( phone: string ) {
    const body = new HttpParams()
      .set('phone', phone)
      .set('forgot', 1)
      .set('device','web');
    return this.httpClient.post(baseUrl+'forgot.php', body.toString());
  }


}
